export default {
  namespaced: true,
  state: {
    adManagerChanged: false,
    idContactManagePost: null,
    mediaUploadDisabled: false
  },
  getters: {
    getAdManagerChanged: (state) => state.adManagerChanged,
    getIdContactManagePost: (state) => state.idContactManagePost,
    mediaUploadDisabled: (state) => state.mediaUploadDisabled
  },
  mutations: {
    setAdManagerChanged (state, adManagerChaged) {
      state.adManagerChanged = adManagerChaged
    },
    setIdContactManagePost (state, idContactManagePost) {
      state.idContactManagePost = idContactManagePost
    },
    SET_MEDIA_UPLOAD_DISABLED (state, mediaUploadDisabled) {
      state.mediaUploadDisabled = mediaUploadDisabled
    }
  }
}
